module.exports = __webpack_public_path__ + "74525743f2dcf36d59cb231f4a699a9a.png";


//////////////////
// WEBPACK FOOTER
// ./demo/img/book_1.png
// module id = 298
// module chunks = 0